import Form from 'react-bootstrap/Form';
import "./CheckBox.scss";

const CheckBox = ({ onCbChange, isChecked, label, type = "checkbox" }) => {
    return (
        <>
            <Form className="appcheckbox">
                <div key={type}>
                    <Form.Check type={type} className="appcheckbox-form">
                        <Form.Check.Input type={type} isValid onChange={onCbChange} checked={isChecked} />
                        <Form.Check.Label>
                            {label}
                        </Form.Check.Label>
                    </Form.Check>
                </div>
            </Form>
        </>
    )
}

export default CheckBox;